module.exports = __webpack_public_path__ + "static/media/Instagram-Icon.607e9d73.svg";